// extracted by mini-css-extract-plugin
export default {"form":"Ko","inline":"Lo","inputWrapper":"Mo","input":"No","withoutLabel":"Oo","error":"Po","label":"Qo"};